
import RcDomainObject from "@/domain/common/RcDomainObject.js";
import OptionMap from "@/domain/model/schedule/question/option/OptionMap.js";

import Catalog from "@/domain/session/Catalog.js";
import StringUtils from '@/utils/StringUtils.js';

export default class Question extends RcDomainObject {
  
  static MODEL_NAME = "VehicleScheduleQuestion";
  
  static Fields = {
    PART: 'part',
    VALUE: 'Value',
    OPTIONS: 'VehicleScheduleQuestionOptionMap',
    TYPE: "type",
    VEHICLE_TYPES: "vehicleTypes",
    VEHICLE_TYPE: "vehicle",
    TRAILER_TYPE: "trailer",
  }
  
  static Values = {
      Type: {
        Text: "text",
        Input: "input",
      }
  }
  
  constructor(domain, data) {
    super(domain, data, Question.MODEL_NAME);
    this.C = new Catalog();
  }

  find() {
    return this.domain.questions().findById(this.id());
  }

  options() {
    return new OptionMap(this.domain, this.get(Question.Fields.OPTIONS));
  }
  
  type() {
    return this.getString(Question.Fields.TYPE);
  }
  
  withTypeText() {
    this.withType(Question.Values.Type.Text);
    return this;
  }
  
  withType(type) {
    this.put(Question.Fields.TYPE, type);
    return this;
  }
  
  name() {
    return this.getString(Question.Fields.VALUE);
  }
  
  part() {
    return this.getString(Question.Fields.PART);
  }
  
  withPart(part) {
    this.put(Question.Fields.PART, part);
    return this;
  }
  
  value() {
    return this.getString(Question.Fields.VALUE);
  }

  hasVehicleType(resultType) {
    let types = this.vehicleTypes();
    let found = StringUtils.contains(types, resultType);
    return found;
  }

  forTrailer() {
    return this.hasVehicleType(Question.Fields.TRAILER_TYPE);
  }

  vehicleTypes() {
    let types = StringUtils.toString(this.getString(Question.Fields.VEHICLE_TYPES));
    return types;
  }

  forVehicleBrakeType(vehicle) {
    let brakingType = vehicle.brakeType();
    if (vehicle.isTrailer()) {
      return (this.forTrailer() && this.hasVehicleType(brakingType));
    }
    return this.hasVehicleType(brakingType);
  }

  forVehicle() {
    return this.hasVehicleType(Question.Fields.VEHICLE_TYPE);
  }

  forType(type) {
    return this.hasVehicleType(type);
  }
}